module.exports = __webpack_public_path__ + "static/img/home13.a33f4b74.png";